import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { invoiceGenGetSettings, invoiceGenUpdateSettings } from "@/lib/api";

export default function PaymentSettingsDialog({ open, onOpenChange }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    invoiceGenGetSettings()
      .then((res) => setText(res.payment_instructions || ""))
      .catch(() => toast.error("Could not load payment details."))
      .finally(() => setLoading(false));
  }, [open]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await invoiceGenUpdateSettings(text);
      toast.success("Payment details saved — every invoice PDF will include them from now on.");
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save payment details.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="invoice-payment-settings-dialog">
        <DialogTitle>Clinic Payment Details</DialogTitle>
        <DialogDescription className="text-sm text-[#6B7280] -mt-1 mb-2">
          A permanent setting — this text is automatically printed under "Pay To" on every invoice
          (Manual and AI Assistant), so it never needs to be re-typed in a chat again.
        </DialogDescription>
        {loading ? (
          <Loader2 className="animate-spin text-[#3A7A8C]" size={20} />
        ) : (
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={"e.g.\nBank: Butterfield Bank\nAccount Name: Ashlan Clinic Ltd\nAccount #: 012345678\nRouting/SWIFT: BNTBBMHM"}
            rows={6}
            data-testid="invoice-payment-settings-textarea"
            className="ash-input resize-none"
          />
        )}
        <button
          type="button"
          onClick={handleSave}
          disabled={saving || loading}
          data-testid="invoice-payment-settings-save-button"
          className="ash-btn-primary mt-3 inline-flex items-center justify-center gap-1.5 disabled:opacity-60"
        >
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save
        </button>
      </DialogContent>
    </Dialog>
  );
}
